import Base from '../../ts/_base';

export default class Menu extends Base {

    get ChildSelectors(): {[key: string]: string} {
        return {
            ...this.selectors,
            mainMenu: '#main-menu',
            dropdownTiggers: 'a[data-toggle="dropdown"][href]'
        }
    }

    public initialize(): void {
        this.controller();
    }


    protected controller(): void {
        const menu = this.queryElm(this.ChildSelectors.mainMenu) as HTMLElement | undefined;
        if(menu) {
            const menuItems = this.queryElm(this.ChildSelectors.dropdownTiggers, true, menu) as NodeListOf<HTMLElement>;
            menuItems.forEach((item) => {
                const href = item.getAttribute('href');
                if(href && href[0] != "#") {
                    item.addEventListener('click', () => this.visitLink(href));
                }
            })
        }
    }


    protected visitLink(link: string): void {
        window.location.href = link;
    }
}